// extracted by mini-css-extract-plugin
module.exports = {"ticket":"Ticket_ticket__1L3U_","place":"Ticket_place__2T58Y","placeName":"Ticket_placeName__jre8x","isMobileTicket":"Ticket_isMobileTicket__PFWCs"};